<template>
    <v-card flat>
        <v-card-text>
            <v-container>
                <v-row>
                    <v-col cols="10" sm="10" md="10">
                        <v-text-field
                            :value="selectedItem.street_name"
                            label="Logradouro"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="2" sm="2" md="2">
                        <v-text-field
                            :value="selectedItem.street_number"
                            label="Número"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                        <v-text-field
                            :value="selectedItem.district"
                            label="Bairro"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                        <v-text-field
                            :value="selectedItem.city"
                            label="Cidade"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                        <v-text-field
                            :value="selectedItem.state"
                            label="Estado"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="6" sm="6" md="6">
                        <v-text-field
                            :value="selectedItem.country ? selectedItem.country.name : ''"
                            label="País"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="9" sm="9" md="9">
                        <v-text-field
                            :value="selectedItem.additional_information"
                            label="Complemento"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                    
                    <v-col cols="3" sm="3" md="3">
                        <v-text-field
                            :value="selectedItem.zip_code | formatZipcode"
                            label="CEP"
                            readonly
                            hide-details="auto"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>


<script>
export default {
  name: 'Address',
  props: {
    selectedItem: {
        type: Object,
        required: true,
    },
  },
}
</script>
